import * as toastr from 'toastr';
import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoComplete } from 'primeng/autocomplete';
import { takeUntil } from 'rxjs/operators';
import { AssinaturaPessoa } from '../../entidade/comum/assinatura-pessoa.model';
import { Assinatura } from '../../entidade/comum/assinatura.model';
import { Pessoa } from '../../entidade/comum/pessoa.model';
import { LoginContabil } from '../../entidade/login/login-contabil';
import { BaseResourceFormComponent } from '../../models/base-resource-form';
import { EddyAutoComplete } from '../../models/form-components';
import { PessoaService } from '../../pessoa/service/pessoa.service';
import { AssinaturaPessoaService } from '../service/assinatura-pessoa.service';
import { AssinaturaService } from '../service/assinatura.service';

@Component({
  selector: 'lib-assinatura-form',
  templateUrl: './assinatura-form.component.html'
})
export class AssinaturaFormComponent extends BaseResourceFormComponent<Assinatura, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  @ViewChild('nome') inputField: ElementRef;

  // membros
  @ViewChild('btnAdicionar') public btnAdicionar: ElementRef;
  @ViewChild('pessoa_') campoPessoa: AutoComplete;
  public pessoaAutoComplete: EddyAutoComplete<Pessoa>;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    protected confirmationService: ConfirmationService,
    private messageService: MessageService,
    protected pessoaService: PessoaService,
    protected assinaturaPessoaService: AssinaturaPessoaService,
    protected assinaturaService: AssinaturaService) {
    super(new Assinatura(), injector, Assinatura.converteJson, assinaturaService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      nome: [null, [Validators.required]],
      ativo: [true, [Validators.required]],
      orgao: [this.login.orgao, [Validators.required]],
      pessoas: [],
    });
  }

  protected parametrosExtras(): {} {
    return { relations: 'pessoas.pessoa' };
  }

  protected afterLoad() {
  }

  protected afterInit(): void {

    this.pessoaAutoComplete = new EddyAutoComplete(null, this.pessoaService,
      'id', ['nome'], { cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['cpf_cnpj'], text: ['nome'] }
    );
  }

  protected campoFoco(): ElementRef {
    return this.inputField;
  }

  protected beforeSubmit() {
    try {
      if (this.entidadeForm.get('nome').value === '') {
        throw new Error('Informe o nome!');
      }
      this.entidadeForm.get('pessoas').setValue(this.entidade.pessoas);
    } catch (e) {
      toastr.error('Validação', e);
      throw e;
    }
  }

  protected afterSubmit(ent: Assinatura) {
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public adicionar() {
    if (this.entidade.pessoas && this.entidade.pessoas.find((itm) => { return itm.editavel === true })) {
      toastr.info('Finalize a edição atual antes de incluir outra pessoa');
      return;
    }

    const pessoaAtual = new AssinaturaPessoa();
    pessoaAtual.editavel = true;

    if (!this.entidade.pessoas || this.entidade.pessoas.length === 0) {
      this.entidade.pessoas = [];
    }

    this.entidade.pessoas.unshift(pessoaAtual);
    this.btnAdicionar.nativeElement.disabled = true;
    setTimeout(() => this.campoPessoa ? this.campoPessoa.focusInput() : null, 500);
  }

  public editar(item: AssinaturaPessoa) {
    if (this.entidade.pessoas && this.entidade.pessoas.find((itm) => { return itm.editavel === true })) {
      toastr.info('Finalize a edição atual antes de editar outra pessoa');
      return;
    }

    item.editavel = true;
    this.btnAdicionar.nativeElement.disabled = true;
  }

  public salvar(item: AssinaturaPessoa) {
    try {
      if (!item.pessoa) {
        throw new Error('Selecione a pessoa!');
      }
      if (!item.cargo) {
        throw new Error('Informe o cargo da pessoa!');
      }

      item.editavel = false;
      this.btnAdicionar.nativeElement.disabled = false;

      if (!this.entidade.id) {
        this.adicionar()
      }
    } catch (e) {
      toastr.warning(e, 'Validação');
      throw e;
    }
  }

  public cancelar(item: AssinaturaPessoa, index: number) {
    if (!item.id && !item.pessoa) {
      this.entidade.pessoas.splice(index, 1);
    }
    item.editavel = false;
    this.btnAdicionar.nativeElement.disabled = false;
  }

  public remover(item: AssinaturaPessoa, index: number) {
    if (item.id) {
      this.confirmationService.confirm({
        message: 'Deseja realmente remover a pessoa?',
        header: 'Exclusão',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Confirmar',
        rejectLabel: 'Cancelar',
        accept: () => {
          this.assinaturaPessoaService.remover(item.id).pipe(takeUntil(this.unsubscribe))
            .subscribe((res) => {
              toastr.info('Registro removido com sucesso!', 'Exclusão');
              this.entidade.pessoas.splice(index, 1);
            }, (err) => toastr.error(err.error.payload));
        }
      });
    } else {
      this.entidade.pessoas.splice(index, 1);
    }
  }

}
